import React, { FC } from 'react';
import cx from 'clsx';

import styles from './styles.module.scss';

const CustomerInfoShimmer: FC = () => (
  <>
    <p className={cx('shimmer', styles.customerInfo)} />
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <div className={cx('shimmer', styles.dualInput)} />
        <div className={cx('shimmer', styles.dualInput)} />
      </div>
      <div className={styles.row}>
        <div className="shimmer" />
      </div>
    </div>
  </>
);

export { CustomerInfoShimmer };
